var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    attrs: {
      "id": "modal-event-container",
      "data-modal-event": ""
    }
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    staticClass: "m-auto",
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', {
    class: _vm.$style.modalEventContainer
  }, [_c('MottoIcon', {
    class: _vm.$style.closeButton,
    attrs: {
      "name": "X",
      "icon-color": "gray",
      "data-close-modal-event-button": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.closeModal.apply(null, arguments);
      }
    }
  }), _c('div', {
    class: _vm.$style.contentContainer
  }, [_c('div', {
    class: _vm.$style.contentHeader
  }, [_c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer"
  }, [_vm._v("EVENTS")])])]), _c('div', {
    staticClass: "position-relative"
  }, [_c('BaseLink', {
    class: _vm.$style.eventTitleLink,
    attrs: {
      "to": {
        name: 'event',
        params: {
          eventId: _vm.eventId
        }
      }
    }
  }, [_c('h2', {
    staticClass: "color-primary-blue",
    class: _vm.$style.eventTitle
  }, [_vm._v(_vm._s(_vm.event.title))])]), _vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIcon
  }) : _vm.event.eventId ? _c('FavoriteHeart', {
    class: _vm.$style.heartIcon,
    attrs: {
      "is-favorite": _vm.isFavorite
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick
    }
  }) : _vm._e(), _c('CopyToClipboardButton', {
    class: _vm.$style.clipboardButton,
    attrs: {
      "text-to-copy": _vm.eventUrl
    }
  })], 1), _c('div', {
    class: _vm.$style.subTitleContent
  }, [!_vm.event.multiDay ? _c('p', {
    staticClass: "p1 color-primary-blue",
    class: _vm.$style.subTitleEventDate
  }, [_vm._v(" " + _vm._s(_vm.getStartTimeTexts.weekdayLong) + ", " + _vm._s(_vm.getStartTimeTexts.month) + " " + _vm._s(_vm.getStartTimeTexts.day) + " ")]) : _vm._e(), _vm.event.multiDay ? _c('p', {
    staticClass: "p1 color-primary-blue",
    class: _vm.$style.subTitleEventDate
  }, [_vm._v(" " + _vm._s(_vm.getStartTimeTexts.weekday) + ", " + _vm._s(_vm.getStartTimeTexts.monthShort) + " " + _vm._s(_vm.getStartTimeTexts.day) + " - " + _vm._s(_vm.getEndTimeTexts.weekday) + ", " + _vm._s(_vm.getEndTimeTexts.monthShort) + " " + _vm._s(_vm.getEndTimeTexts.day) + " ")]) : _vm._e(), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('MottoIcon', {
    staticClass: "mr-10",
    attrs: {
      "name": "Clock",
      "icon-color": "gray"
    }
  }), _c('p', {
    staticClass: "p1 color-primary-blue"
  }, [_vm._v(" " + _vm._s(_vm.event.allDay ? "ALL DAY" : "".concat(_vm.getStartTimeTexts.time, " - ").concat(_vm.getEndTimeTexts.time)) + " ")])], 1)])]), _c('p', {
    staticClass: "p1 color-primary-charcoal",
    class: _vm.$style.eventTextContent
  }, [_vm._v(_vm._s(_vm.event.description))]), _vm.getAudienceSentence ? _c('div', {
    class: _vm.$style.audienceDetails
  }, [_c('MottoIcon', {
    attrs: {
      "name": "UserGroup",
      "icon-color": "gray"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.getAudienceSentence))])], 1) : _vm._e(), _c('div', {
    class: _vm.$style.locationDetails
  }, [_c('MottoIcon', {
    attrs: {
      "name": "Place",
      "icon-color": "gray"
    }
  }), _c('p', {
    staticClass: "p1 color-primary-charcoal"
  }, [_vm._v(" " + _vm._s(_vm.event.meetingType) + " "), _vm.event.location ? [_vm._v("- " + _vm._s(_vm.event.location))] : _vm._e()], 2)], 1), _vm._l(_vm.event.urls, function (url) {
    return _c('div', {
      key: url.url,
      class: _vm.$style.urlDetails
    }, [_c('MottoIcon', {
      attrs: {
        "name": "LinkChain",
        "icon-color": "gray"
      }
    }), _c('p', {
      on: {
        "click": function click($event) {
          return _vm.openEventUrl(url);
        }
      }
    }, [_vm._v(_vm._s(url.url))])], 1);
  }), _vm.getEventPosts.length ? _c('div', {
    class: _vm.$style.supportingFiles
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('MottoIcon', {
    attrs: {
      "name": "Resources",
      "icon-color": "gray"
    }
  }), _c('p', {
    staticClass: "tag-text color-dark-gray"
  }, [_vm._v("Supporting Files")])], 1), _c('div', {
    class: _vm.$style.supportingFilesGrid
  }, _vm._l(_vm.getEventPosts, function (resource) {
    return _c('ResourceBlock', {
      key: resource.resourceId,
      class: _vm.$style.resourceBlock,
      attrs: {
        "minimal-design": true,
        "resource": resource
      }
    });
  }), 1)]) : _vm._e()], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }